import { useParams } from "react-router";
import { useLocale } from "use-intl";
import { planWeek } from "@liftquest/shared/dates";
import { ll, lt } from "@liftquest/shared/localized";
import { phaseForWeek } from "@liftquest/shared/plan-logic";
import { Page, PageHeader } from "@/components/app/page-header";
import { NotFound, PageLoading } from "@/components/app/states";
import { workoutMinutes } from "@/lib/duration";
import { useMe, usePlan } from "@/lib/queries";
import { PlanActions } from "./plan-actions";
import { PlanEditor } from "./plan-editor";

export function PlanPage() {
  const { planId = "" } = useParams();
  const { profile } = useMe().data!;
  const locale = useLocale();
  const { data: plan, isPending } = usePlan(planId);
  if (isPending) return <PageLoading />;
  if (!plan) return <NotFound />;
  const week = planWeek(plan.startDate);
  const phase = phaseForWeek(plan.phases, week);
  const hasWarmup = ll(plan.warmup, locale).length > 0;

  return (
    <Page>
      <PageHeader
        backHref="/plans"
        title={lt(plan.name, locale)}
        actions={<PlanActions planId={plan.id} planName={lt(plan.name, locale)} active={profile.activePlanId === plan.id} />}
      />
      <PlanEditor
        key={plan.id}
        plan={{
          id: plan.id,
          name: plan.name,
          description: plan.description,
          startDate: plan.startDate,
          trainingDays: plan.trainingDays,
          cardioDays: plan.cardioDays,
          warmup: plan.warmup,
          tips: plan.tips,
          phases: plan.phases,
        }}
        currentWeek={week}
        workouts={plan.workouts.map((w) => ({
          id: w.id,
          name: lt(w.name, locale),
          focus: lt(w.focus, locale),
          kind: w.kind,
          exercises: w.exercises.map((e) => lt(e.exercise.name, locale)),
          minutes: workoutMinutes(w.exercises, w.kind === "strength" ? phase : null, w.kind === "strength" && hasWarmup),
        }))}
      />
    </Page>
  );
}
